import React, { useCallback, useContext, useEffect, useState } from 'react';
import { withAuthorization } from '../../components/Session';
import { GoBackButton } from '../../components/Navigation';
import FreightForwarderForm from './form';
import Spinner from '../../components/Spinner';

import Typography from '@material-ui/core/Typography';
import * as ROLES from '../../constants/roles';

import { compose } from 'recompose';
import Grid from '@material-ui/core/Grid';
import { FirebaseContext } from '../../components/Firebase';
import { FreightForwarder, User } from '../../../types';
import { useHistory } from 'react-router-dom';

const FreightForwarderEditPage: React.ComponentType<any> = ({
  freight_forwarder_id,
}: {
  freight_forwarder_id: string;
}) => {
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [currentFreightForwarder, setCurrentFreightForwarder] = useState<FreightForwarder>();
  const firebase = useContext(FirebaseContext);

  const getFreightForwarder = useCallback(() => {
    return firebase.freightForwarder(freight_forwarder_id).then((_freightForwarder: FreightForwarder) => {
      setCurrentFreightForwarder(_freightForwarder);
    });
  }, [firebase, freight_forwarder_id]);

  useEffect(() => {
    setLoading(true);
    Promise.all([getFreightForwarder()]).then(() => {
      setLoading(false);
    });
  }, [getFreightForwarder]);

  const save = (freightForwarder: Partial<FreightForwarder>) => {
    setLoading(true);
    firebase
      .freightForwarderUpdate(freightForwarder)
      .then((updatedFreightForwarder: FreightForwarder) => {
        setCurrentFreightForwarder(updatedFreightForwarder);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDelete = (freightForwarder: Partial<FreightForwarder>) => {
    setLoading(true);
    firebase
      .freightForwarderDelete(freightForwarder)
      .then(() => {
        setLoading(false);
        history.push(`/admin/freight-forwarders`);
      })
      .catch(() => setLoading(false));
  };

  return (
    <div>
      <Spinner visible={loading} />
      {currentFreightForwarder && (
        <div>
          <Grid container spacing={3}>
            <Grid item xs={6}>
              <Typography variant="h1">Edit Freight Forwarder</Typography>
            </Grid>
            <Grid item xs={6}>
              <Grid container justifyContent="flex-end">
                <GoBackButton />
              </Grid>
            </Grid>
          </Grid>
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <FreightForwarderForm
                freightForwarder={currentFreightForwarder}
                onSubmit={save}
                onDelete={handleDelete}
                submitButtonText="Save Changes"
              />
            </Grid>
          </Grid>
        </div>
      )}
    </div>
  );
};

const condition = (authUser: User) => authUser && authUser.roles && authUser.roles.includes(ROLES.ADMIN);

export default compose(withAuthorization(condition))(FreightForwarderEditPage);
